import { Tooltip } from 'seagull';
import { getAccountingDetails } from "../../integrations/Accounting/accounting.utils";
import { formatDateTimeWithShortMonth } from "../../utils/date-formatting";
import { accountingIconMap } from "../../integrations/Accounting/AccountingIcon/accountingIconMap";
import { jsx as _jsx } from "react/jsx-runtime";
const accountingName = accountingType => getAccountingDetails(accountingType).fullName;
function getTooltip(integration, accountingType) {
  return integration.accept({
    whenPendingSync: () => "Pending invoice sync to ".concat(accountingName(accountingType)),
    whenInvoiceSyncFailed: () => "Invoice sync failed in ".concat(accountingName(accountingType)),
    whenPaymentSyncFailed: () => "Payment sync failed in ".concat(accountingName(accountingType)),
    whenRefundSyncFailed: () => "Refund sync failed in ".concat(accountingName(accountingType)),
    whenInvoiceRecorded: _ref => {
      let {
        date
      } = _ref;
      return "Invoice recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
    },
    whenVoidedRecorded: _ref2 => {
      let {
        date
      } = _ref2;
      return "Invoice recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
    },
    whenRefundRecorded: _ref3 => {
      let {
        date
      } = _ref3;
      return "Refund recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
    },
    whenPaymentRecorded: _ref4 => {
      let {
        date
      } = _ref4;
      return "Payment recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
    }
  });
}
function getAccountingIcon(integration, accountingType) {
  const status = getInvoiceIntegrationStatus(integration);
  return status ? accountingIconMap[accountingType][status] : null;
}
function getInvoiceIntegrationStatus(integration) {
  if (integration.isSynced()) {
    return 'success';
  } else if (integration.isSyncFailed()) {
    return 'error';
  } else if (integration.isPendingSync()) {
    return 'pending';
  } else {
    return null;
  }
}
export function InvoiceAccountingIntegrationStatus(props) {
  const {
    className,
    testid,
    invoiceIntegration,
    placement = 'top',
    accountingType
  } = props;
  return invoiceIntegration ? /*#__PURE__*/_jsx("div", {
    "data-testid": testid,
    className: className,
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx("div", {
        "data-testid": "".concat(testid, "-tooltip"),
        children: getTooltip(invoiceIntegration, accountingType)
      }),
      placement: placement,
      children: /*#__PURE__*/_jsx("span", {
        style: {
          display: 'inline'
        },
        children: getAccountingIcon(invoiceIntegration, accountingType)
      })
    })
  }) : null;
}